import React from 'react';

import styled from '@emotion/styled';

import { Table, NavLinkButton } from '@shared/components/bootstrap';

import { Panel } from '@admin/components/helpers/panel';
import { Landing__Location__Content } from '@admin/schema';

const Links = styled.div`
  display: flex;
  gap: 4px;
`;

export const List: React.FC<{
  location: {
    globalID: string;
    contents: Array<Pick<Landing__Location__Content, 'id' | 'service'>>;
  };
}> = ({ location }) => (
  <Panel>
    <Panel.Header>
      <Panel.Title>Content</Panel.Title>
    </Panel.Header>
    <Panel.Body>
      <Table striped responsive>
        <thead>
          <tr>
            <th className="text-left">ID</th>
            <th className="text-left">Service</th>
            <th className="col-zero" />
          </tr>
        </thead>
        <tbody>
          {location.contents.map((content) => (
            <tr key={content.id}>
              <td className="text-left">{content.id}</td>
              <td className="text-left">{content.service}</td>
              <td className="col-zero">
                <Links>
                  <NavLinkButton kind="primary" to={`/landing/location/contents/${content.id}`}>
                    View
                  </NavLinkButton>
                  <NavLinkButton kind="primary" to={`/landing/location/contents/${content.id}/edit`}>
                    Edit
                  </NavLinkButton>
                </Links>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Panel.Body>
    <Panel.Footer align="right">
      <NavLinkButton kind="default" to={`/landing/location/contents/new?location_id=${location.globalID}`}>
        Add
      </NavLinkButton>
    </Panel.Footer>
  </Panel>
);
